<template>
  <div v-if="type === 'navigate'" class="input navigareInput">
    <input type="text" :placeholder="placeholder" :value="inputValue" @input="inputHandler($event)">
    <img class="submitIcon" ref="subIcon" @click="allowClick && navigate()" src="@/assets/icon/submit.png" alt="submit">
    <div class="backfill"></div>
  </div>
  <div v-else :class="`input ${type}` + (layout? ' '+layout:'')">
    <input type="text" :placeholder="placeholder" :value="inputValue" @input="inputHandler($event)">
  </div>
</template>

<script>
export default {
  name: "Input",
  props: {
    placeholder: String,
    inputValue: String,
    type: String,
    nextPage: String,
    layout: String
  },
  data() {
    return {
      allowClick: false,
    }
  },
  mounted(){
    if(this.$refs.subIcon && this.inputValue && this.inputValue.length > 0){
      this.$refs.subIcon.style.opacity = 1
      this.$refs.subIcon.style.cursor = 'pointer'
      this.allowClick = true
    }else if(this.$refs.subIcon){
      this.$refs.subIcon.style.opacity = 0.5
      this.$refs.subIcon.style.cursor = 'default'
      this.allowClick = false
    }
  },
  methods: {
    inputHandler(e){
      // this.inputValue = this.inputValue.trim()
      // if(this.inputValue.length === 0){return}
      this.$emit('input', e.target.value)
      
      if(this.type === 'navigate'){
        if(e.target.value.trim().length > 0){
          this.$refs.subIcon.style.opacity = 1
          this.$refs.subIcon.style.cursor = 'pointer'
          this.allowClick = true
        }else{
          this.$refs.subIcon.style.opacity = 0.5
          this.$refs.subIcon.style.cursor = 'default'
          this.allowClick = false
        }
      }
    },
    navigate(){
      this.$emit('navigate', this.inputValue)
      this.$router.push(this.nextPage)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.input{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  input{
    width: 790px;
    height: 80px;
    border-radius: 40px;
    background-color: #fff;
    padding: 20px 100px 20px 40px;
    border: 0;
    font-family: var(--font_family);
    font-size: 22px;
  }
  input:focus-visible, input:hover{
    outline: 0;
    border: 2px solid var(--main_color);
  }
  input::placeholder{
    opacity: .7;
  }
  .submitIcon{
    height: 36px;
    margin-left: -60px;
    opacity: 0.5;
  }
  .backfill{
    width: 39px;
  }
}
.normal{
  input{
    text-align: center;
  }
}
.layout_left{
  width: 100%;
  justify-content: flex-start;
}
@media only screen and (max-width: 767px){
  .input{
    margin-top: 0px;
    input{
      width: 240px;
      height: 40px;
      padding: 12px 24px;
      font-size: 16px;
      text-align: center;
    }
    .submitIcon{
      height: 22px;
      margin-left: -30px;
      opacity: 0.5;
    }
    .backfill{
      width: 17px;
    }
  }
  .navigareInput{
    input{
      width: 100%;
      max-width: 290px;
      height: 50px;
      padding: 12px 60px 12px 24px;
    }
  }
}
</style>
